import { AcordoAccordion } from "./components/acordo";
import { ResumoAcordoAccordion } from "./components/resumo";

interface ResumoAcordoAccordionProps {
  formaPag: string;
  vencimento: string;
  app: string
}


export const ResumoAcordo = ({ formaPag, vencimento, app }: ResumoAcordoAccordionProps) => {
  return (
    <div>
      <ResumoAcordoAccordion formaPag={formaPag} vencimento={vencimento} app={app} />
      <AcordoAccordion formaPag={formaPag} app={app} />
    </div>
  );
};
